var lists_default = {
  "fontElementMap": "L4SPW",
  "orderedlist": "T9aHf",
  "bulletedlist": "oonoW",
  "listItem": "cXLS2"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
